import { FC } from 'react';

import { TProductItemConfig } from '@/components/modules/orders-page/orders/ui/product-item';

import { useTranslate } from '@/shared/hooks/use-translate';
import { priceFormat } from '@/shared/utils/currency';

import { ActionCancel } from '../action-cancel';

import * as Styled from './styled';

type TProps = {
    config: TProductItemConfig;
    price: number;
    priceReturned: string;
    number: string;
};

export const Approved: FC<TProps> = ({ config, price, priceReturned, number }) => {
    const { t } = useTranslate();

    const isBuyoutMonth = config.termUnit === 2 && config.isBuyout;

    const bail = {
        name: isBuyoutMonth ? 'Авансовый платеж' : 'Возвратный залог',
        sum: priceFormat(Number(priceReturned), 0),
        description: isBuyoutMonth
            ? 'Эта сумма будет зачислена в оплату первых месяцев аренды'
            : 'Мы используем залог только в качестве гарантии возврата товара',
    };

    return (
        <Styled.Wrapper>
            <Styled.PriceBlock>
                <div>{t('К оплате в отделении')}</div>
                <div>
                    {config.termUnit === 2
                        ? priceFormat(Number(priceReturned), 0)
                        : priceFormat(price + Number(priceReturned), 0)}
                    &nbsp;₸
                </div>
            </Styled.PriceBlock>

            {config.termUnit === 1 && (
                <div className="price">
                    <div>{t('Стоимость аренды')}</div>
                    <div>{priceFormat(price as number, 0)}&nbsp;₸</div>
                </div>
            )}

            <div className="price">
                <div>{t(bail.name)}</div>
                <div>{bail.sum}&nbsp;₸</div>
            </div>
            <div className="price_info">{t(bail.description)}</div>

            <ActionCancel number={number} />
        </Styled.Wrapper>
    );
};
